import { OverlayArrow } from "react-aria-components";
import { popoverStyle } from "./style.js";

export const PopoverArrow = () => (
  <OverlayArrow>
    <svg viewBox="0 0 12 12" className={popoverStyle().arrowSvg()}>
      <path className={popoverStyle().arrowPath()} d="M0 0L6 6L12 0" />
    </svg>
  </OverlayArrow>
);
